import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-d3e-device-compliance',
    templateUrl: './d3e-device-compliance.component.html',
    styleUrls: ['./d3e-device-compliance.component.scss'],
    standalone: false
})
export class D3eDeviceComplianceComponent {
  @Input() compliant: boolean;
  @Input() isNA = false;
}